module.exports = __webpack_public_path__ + "static/img/banner.3d08077.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/iot/banner.png
// module id = i0pH
// module chunks = 0